<!--  -->
<template>
  <div class="NewsDetails">
    <h1>
      <router-link to="/">{{ shouye }}</router-link>
      >
      <router-link to="/News">{{ xiangqing }}</router-link>
    </h1>

    <h2>{{ NewsDetails_title }}</h2>

    <p>
      <span>{{ date }}: {{ time }}</span>
      <span>{{ page_view }}: {{ view_numb }}</span>
    </p>

    <div class="News_msg" v-html="msg"></div>

    <div class="page">
      <div class="previous">
        <router-link :to="PreviousUrl" @click.native="refresh">
          <p>{{ Previous }}: {{ Previous_title }}</p>
        </router-link>
      </div>
      <div class="next">
        <router-link :to="NextUrl" @click.native="refresh">
          <p>{{ Next }}:{{ Next_title }}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // 面包屑
      shouye: "",
      xiangqing: "",

      NewsDetails_title:
        "Participants of Mianyang konjac industry on-site observation and training meeting visited Dongfang magic",

      date: "时间",
      page_view: "浏览量",
      time: "2021.03.05",
      view_numb: "255",

      // 新闻详情内容
      msg: ``,

      //   上一页
      Previous: "Previous",
      PreviousUrl: "",
      Previous_title:
        "Z participants said that they had more confidence in Konjac planting and rough processing after visiting our production plant and understanding our whole industrial chain development model.",

      Next: "Next",
      NextUrl: "",
      Next_title:
        "Zheng Shenghua, general manager of the company, introduced the development of konjac industry of the company in detail and said that the company should vigorously develop konjac planting base, strengthen training and technical services, establish a stable breeding base for improved varieties, and increase comprehensive pest control. In the process of development, the enterprise should be market-oriented, study the consumption needs of different groups, develop marketable products, and carry out research and development of new technologies Make great efforts in new product development to really strengthen and expand this sunrise industry.",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getData(id) {
      var that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_article",
          article_id: id,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.NewsDetails_title = obj.data.title;
            that.time = obj.data.create_times;
            that.msg = obj.data.msg;
            that.view_numb = obj.data.view

            that.Previous_title = obj.data.shangpian.title;
            if (obj.data.shangpian.id == 0) {
              that.PreviousUrl = {
                path: "/News/NewsDetails?id=" + obj.data.id,
              };
            } else {
              that.PreviousUrl = {
                path: "/News/NewsDetails?id=" + obj.data.shangpian.id,
              };
            }

            that.Next_title = obj.data.xiapian.title;
            if (obj.data.xiapian.id == 0) {
              that.PreviousUrl = {
                path: "/News/NewsDetails?id=" + obj.data.id,
              };
            } else {
              that.NextUrl = {
                path: "/News/NewsDetails?id=" + obj.data.xiapian.id,
              };
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },

    refresh: function () {
      this.$router.go(0);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getData(this.$route.query.id);
    var that = this;
    var nid = this.$route.query.nid;
    $.ajax({
          url: "/index.php?s=Home/Api/get_data",
          type: "get",
          datatype: "json",
          data: {
            act: "get_all_nav_parent",
            nid: nid,
            showlast:1
          },
          success: function (ret) {
            var obj = JSON.parse(ret); //json数据转为数组
            if (obj.code == "0000") {
                that.shouye = obj.data[0].title;
                that.xiangqing = obj.data[1].title;
            }
          },
          error: function (err) {
            console.log("ajax错误");
          },
        });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.NewsDetails {
  width: 100%;
  padding: 55px 9.25rem 110px;
  h1 {
    font-size: 1.2rem;
    font-weight: bold;
    color: #969696;
  }
  h2 {
    margin-top: 50px;
    text-align: center;
    font-size: 1.4rem;
    font-weight: bold;
    color: #39404a;
    line-height: 1.5;
    padding: 0 255px;
  }
  p {
    text-align: center;
    font-size: 0.8rem;
    font-weight: bold;
    color: #999999;
    margin-top: 40px;
    span {
      margin: 0 10px;
    }
  }
  .News_msg {
    width: 100%;
    margin-top: 60px;
  }
  .News_msg >>> img {
    max-width: 100%;
    margin: 0 auto;
  }

  .page {
    width: 100%;
    height: 60px;
    background: #e6e6e6;
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
    .previous {
      width: 50%;
      transition: 0.3s;
      a {
        display: flex;
        align-items: center;
        padding: 0 30px 0 20px;
        width: 100%;
        height: 100%;
        font-size: 0.9rem;
        font-weight: 400;
        p {
          height: 100%;
          margin-top: 0;
          line-height: 60px;
          color: #39404a;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          transition: 0.3s;
        }
      }
    }
    .previous:hover {
      background: #5fbb68;
    }
    .previous:hover p {
      color: #ffffff;
    }
    .next {
      width: 50%;
      transition: 0.3s;
      a {
        display: flex;
        align-items: center;
        padding: 0 20px 0 30px;
        width: 100%;
        height: 100%;
        font-size: 0.9rem;
        font-weight: 400;
        p {
          height: 100%;
          margin-top: 0;
          line-height: 60px;
          color: #39404a;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          transition: 0.3s;
          text-align: right;
        }
      }
    }
    .next:hover {
      background: #5fbb68;
    }
    .next:hover p {
      color: #ffffff;
    }
  }
}
@media screen and (max-width: 1200px) {
  .NewsDetails {
    padding: 40px 10px;
    h2 {
      margin: 40px auto;
      padding: 0 10px;
      font-size: 1.2rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/New/NewsDetails.vue